import { useFrame } from '@react-three/fiber';
import { useContext, useEffect, useRef, useState } from 'react';
// import { useDrag } from '@use-gesture/react';
import * as THREE from 'three';

import { ViewContext } from '@/state/contexts';

const BOX_SIZE = 0.8;
const START_Y = -20;
const HOVER_HEIGHT = 1;

const ENTRANCE_SPEED = 3;
const HOVER_SPEED = 10;

// Create a reusable vector outside your handler or component to avoid garbage collection
const tempWorldVector = new THREE.Vector3();

export default function EnergyComposed({ energy }) {
	const { paymentMode }: any = useContext(ViewContext);

	const meshRef = useRef<THREE.Mesh>(null!);

	const [dragging, setDragging] = useState(false);

	const animatedY = useRef(START_Y);

	const dragPlane = useRef(
		new THREE.Plane(new THREE.Vector3(0, 1, 0), -HOVER_HEIGHT)
	).current;

	const intersection = useRef(new THREE.Vector3()).current;
	const grabOffset = useRef(new THREE.Vector3());

	useEffect(() => {
		meshRef.current.position.set(
			energy.homePosition[0],
			START_Y,
			energy.homePosition[2]
		);

		animatedY.current = START_Y;
	}, [energy]);

	useFrame((_, delta) => {
		const targetY =
			paymentMode && dragging ? HOVER_HEIGHT : energy.homePosition[1];

		const speed = dragging ? HOVER_SPEED : ENTRANCE_SPEED;

		animatedY.current = THREE.MathUtils.lerp(
			animatedY.current,
			targetY,
			delta * speed
		);

		meshRef.current.position.y = animatedY.current;
	});

	function handlePointerDown(e: any) {
		if (!paymentMode) return;

		e.stopPropagation();

		setDragging(true);

		if (e.ray.intersectPlane(dragPlane, intersection)) {
			grabOffset.current.copy(intersection).sub(meshRef.current.position);
		}
	}

	function handlePointerMove(e: any) {
		if (!dragging) return;

		e.stopPropagation();

		if (e.ray.intersectPlane(dragPlane, intersection)) {
			meshRef.current.position.x = intersection.x - grabOffset.current.x;

			meshRef.current.position.z = intersection.z - grabOffset.current.z;
		}
	}

	function handlePointerUp(e: any) {
		if (!dragging) return;

		e.stopPropagation();
		setDragging(false);

		if (meshRef.current) {
			// 1. Force Three.js to calculate the latest position matrix
			meshRef.current.updateMatrixWorld(true);

			// 2. Extract the absolute 3D world position into our temporary vector
			meshRef.current.getWorldPosition(tempWorldVector);

			// 3. Pass a cloned copy of the true world position to your onDrop function
		}
	}

	return (
		<mesh
			ref={meshRef}
			onPointerDown={handlePointerDown}
			onPointerMove={handlePointerMove}
			onPointerUp={handlePointerUp}
		>
			<boxGeometry args={[BOX_SIZE, BOX_SIZE, BOX_SIZE]} />
			<meshBasicMaterial color={energy.color} />
		</mesh>
	);
}

/*

import { useRef } from 'react';
import Animator from '@/components/game/3d/animation/Animator';

const EnergyComposed = ({
	energyColor,
	index
}) => {
	const scale = 0.8;
	const boxDim = 1 * scale;

	const meshRef = useRef<any>(null);

	const animationParam = {
		position_x_offset: index * 1.5,
		position_y_start: -3,
		position_y_final: 0
	}

	const energyMesh = () => {
		return (
			<mesh
				visible
				ref={meshRef}
				userData={{ hello: 'world' }}
			>
				<boxGeometry args={[boxDim, boxDim, boxDim]} />
				<meshBasicMaterial color={energyColor} />
			</mesh>
		);
	}

	return (
		<group dispose={null}>
			<Animator
				customMesh={energyMesh()}
				meshRef={meshRef}
				animationParam={animationParam}
			/>
		</group>
	);
};

export default EnergyComposed;
*/
